var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1636)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.00008C4.68662 2.00008 2.00033 4.68637 2.00033 8.00008C2.00033 11.3138 4.68662 14.0001 8.00033 14.0001C11.314 14.0001 14.0003 11.3138 14.0003 8.00008C14.0003 4.68637 11.314 2.00008 8.00033 2.00008ZM0.666992 8.00008C0.666992 3.94999 3.95024 0.666748 8.00033 0.666748C12.0504 0.666748 15.3337 3.94999 15.3337 8.00008C15.3337 12.0502 12.0504 15.3334 8.00033 15.3334C3.95024 15.3334 0.666992 12.0502 0.666992 8.00008Z",
    fill: "#197BA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 4.66675C8.36786 4.66675 8.66634 4.96522 8.66634 5.33341V10.6667C8.66634 11.0349 8.36786 11.3334 7.99967 11.3334C7.63148 11.3334 7.33301 11.0349 7.33301 10.6667V5.33341C7.33301 4.96522 7.63148 4.66675 7.99967 4.66675Z",
    fill: "#197BA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 7.99992C4.66699 7.63173 4.96547 7.33325 5.33366 7.33325H10.667C11.0352 7.33325 11.3337 7.63173 11.3337 7.99992C11.3337 8.36811 11.0352 8.66659 10.667 8.66659H5.33366C4.96547 8.66659 4.66699 8.36811 4.66699 7.99992Z",
    fill: "#197BA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.cb4e92411b6827fee7ae07238b9526ef.svg";
export { ForwardRef as ReactComponent };